import { render, staticRenderFns } from "./Saddress.vue?vue&type=template&id=27af78cc&"
import script from "./Saddress.vue?vue&type=script&lang=ts&"
export * from "./Saddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports